import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { EntryType } from "@sharedV11/classes/entradas-y-promociones/tipo-entrada/entry-type";
import { JSON2ControlComponent } from "@sharedV11/components/json2control/json2control.component";
import { AlertService } from "@sharedV11/services/alerts/alert/alert.service";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { EntryTypeService } from "@sharedV11/services/components/entradas-y-promociones/entry-type/entry-type.service";
import { GlobalService } from "@sharedV11/services/global/global.service";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-edit-entry-type",
  templateUrl: "./edit-entry-type.component.html",
  styleUrls: ["./edit-entry-type.component.scss"],
})
export class EditEntryTypeComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();

  loading = true;
  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;
  @ViewChild("jsonfield") jsonfield: JSON2ControlComponent;
  @ViewChild("taxonomiaInfoFooter") taxonomiaInfoFooter?: ElementRef<HTMLElement>;
  @ViewChild("taxonomiaNivelesAnchor")
  taxonomiaNivelesAnchor?: ElementRef<HTMLElement>;

  myJSON = '{"UsoMonedero":"0"}'; //customan

  configJSON = [
    {
      atributo: "UsoMonedero",
      title: "Tarjeta Monedero",
      help: "Tarjeta monedero: 0: Debe ser la etiqueta 'No aplica' que ser? el valor por defecto.  1: Debe ser la etiqueta 'Asignaci?n manual'. 2: Debe ser la etiqueta 'Asignaci?n autom?tico'",
      type: "number",
    },
  ];

  translation;

  format = {
    add: "A?adir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

  editorRegistroForm: FormGroup;

  entryType: EntryType;
  submitted = false;

  //---
  // GetTiposEntradaDatos
  TiposEntradaDatosAPI: any;
  tiposEntradaDatos: any[] = [];
  // GetGruposAsociados
  GruposAsociadosAPI: any;
  gruposAsociadosDatos: any[] = [];
  // GetTiposNiveles
  TiposNivelesAPI: any;
  tiposNivelesDatos: any[] = [];
  // GetTiposProductos
  TiposProductosAPI: any;
  tiposProductosDatos: any[] = [];
  // ObtenerCustomanTipoVisita
  TipoVisitaAPI: any;
  tipoVisitaDatos: any[] = [];
  // ObtenerCustomanTipoPublico
  TipoPublicoAPI: any;
  tipoPublicoDatos: any[] = [];
  // ObtenerCustomanTipoPublico
  TipoVisitanteAPI: any;
  tipoVisitanteDatos: any[] = [];
  // ObtenerCustomanNivel
  NivelAPI: any;
  NivelDatos: any[] = [];
  // ObtenerCustomanCategoria
  CategoriaAPI: any;
  categoriaDatos: any[] = [];
  // ObtenerCustomanCentroCoste
  CentroCosteAPI: any;
  centroCosteDatos: any[] = [];
  // ObtenerCustomanCanalesSub
  CanalesAPI: any;
  canalesDatos: any[] = [];
  // getCentros
  CentrosAPI: any;
  tipoCentros: any[] = [];

  // getTiposControlAsync
  tiposTiposControl: Array<any>;

  // getGruposTiposEntradaAsync
  tiposGrupoTipoEntrada: Array<any>;
  tiposGrupoTipoEntradaSinMotivo: Array<any>;
  tiposGrupoTipoEntradaMotivo: Array<any>;

  // getRecintosAsync
  tiposRecinto: Array<any>;

  // getTiposButacaAsync
  tiposTiposButaca: Array<any>;

  //
  centrosasociados: string[] = [];
  actividadesasociadas: string[] = [];
  recintosasignados: string[] = [];
  ordenRecintosAsociados: string[] = [];
  tiposBotoneraEntrada: Array<any>; //      this.cargarBotonera();

  //recintos
  recintosSinAsignar = [];
  recintosAsignados = [];
  //actividades
  actividadesSinAsignar = [];
  actividadesAsignadas = [];
  //centros
  centrosSinAsignar = [];
  centrosAsignados = [];

  /** AppConfig (localStorage), mismo criterio que edit-tipo-abonado. */
  asociarCentros = false;
  asociarCentrosCosteCanales = false;
  taxonomiaActiva = false;

  txCentroCoste: any[] = [];
  txTipoPrecio: any[] = [];
  txCanalVentas: any[] = [];
  txAlojamiento: any[] = [];
  txNiveles: { [nivel: number]: any[] } = {};
  taxonomiaRevenueCategory = "";
  taxonomiaCuentaVisitante = "";
  ultimoNivelTaxonomiaLeaf: any = null;
  submitValidationTick = 0;
  private taxonomiaCabeceraWatchInited = false;
  private valuedChangedSub: Subscription;

  // complementos
  complementosDisponibles: any[] = [];
  opcionesComplemento: Array<{ Nombre: string; pkId: string }> = [];
  complementoMethods: { [index: number]: any } = {};
  opcionMethods: { [index: number]: any } = {};
  constructor(
    public translator: Translator,
    private formBuilder: FormBuilder,
    private _cds: ChangeDetectorRef,
    private panelService: PanelService,
    private servicioAPI: ConectarApiService,
    private entryTypeService: EntryTypeService,
    public global: GlobalService,
    private alertaServicio: AlertService,
    private httpErrorService: HttpErrorsService,
    private snackvar_service: SnackbarInfoService
  ) {}

  ngAfterViewInit() {
    this._cds.detectChanges();
  }

  ngOnDestroy(): void {
    this.valuedChangedSub?.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private static flagActivo(valor: string | null | undefined): boolean {
    if (valor == null || valor === "") return false;
    const s = String(valor).trim().toLowerCase();
    return s === "1" || s === "true";
  }

  private initConfigFlags(): void {
    this.asociarCentros = EditEntryTypeComponent.flagActivo(
      localStorage.getItem("AsociarCentros")
    );
    this.asociarCentrosCosteCanales = EditEntryTypeComponent.flagActivo(
      localStorage.getItem("AsociarCentrosCosteCanales")
    );
    this.taxonomiaActiva = EditEntryTypeComponent.flagActivo(
      localStorage.getItem("Taxonomia")
    );
  }

  private static strId(v: any): string {
    if (v === null || v === undefined || v === "") return "";
    return String(v);
  }

  private static idTaxonomiaDesdeNodoIfAny(
    nodo: any,
    claves: string[]
  ): string | null {
    if (!nodo || typeof nodo !== "object") {
      return null;
    }
    for (const k of claves) {
      const val = nodo[k];
      if (val === null || val === undefined) {
        continue;
      }
      const s = String(val).trim();
      if (s === "" || s === "0") {
        continue;
      }
      return s;
    }
    return null;
  }

  async ngOnInit() {
    this.translation = this.translator.GetTranslations();
    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };

    this.opcionesComplemento = [
      {
        Nombre:
          this.translation.Desglosar ||
          this.translation.Desglose ||
          "Desglose",
        pkId: "1",
      },
      {
        Nombre: this.translation.Imprimir,
        pkId: "2",
      },
    ];

    this.configJSON = [
      {
        atributo: "UsoMonedero",
        title: this.translator.translateV2("Tarjeta Monedero", "CAPITALIZE"),
        help: "Tarjeta monedero: 0: Debe ser la etiqueta 'No aplica' que ser? el valor por defecto.  1: Debe ser la etiqueta 'Asignaci?n manual'. 2: Debe ser la etiqueta 'Asignaci?n autom?tico'",
        type: "number",
      },
    ];

    this.initConfigFlags();
    this.generateForm();
    await this.cargarDatosAsync();
  }

  save() {
    this.loading = false;
    this.panelService.setDiscardChanges(true);

    this.panelService.setSavePanel(null);
  }
  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }
  discard() {
    // Restaura o formul?rio ao estado original carregado da API
    if (this.entryType) {
      this.setValuesForm(this.entryType);
      this.recintosAsignados = this.daTiposRecintos(true);
      this.actividadesAsignadas = this.daTiposRecintos(false);
      this.centrosAsignados = this.daTiposCentros();
      this.loadComplementosFromEntryType(this.entryType);
      void this.restaurarTaxonomiaTrasDescartar(this.entryType);
      this.editorRegistroForm.markAsPristine();
      this.editorRegistroForm.markAsUntouched();
      this.submitted = false;
      this.submitValidationTick = 0;
      this.panelService.setDiscardChanges(true);
    }
  }
  submit() {
    this.submitted = true;
    if (this.taxonomiaActiva) {
      this.submitValidationTick++;
    }
    this.editorRegistroForm.markAllAsTouched();
    const missing = this.getMissingRequiredFieldsLabels();
    if (missing.length > 0 || this.editorRegistroForm.invalid) {
      const msg =
        this.translation?.FaltanCamposRequeridos ||
        this.translation?.FaltanCamposObligatorios ||
        "Faltan Campos Obligatorios";
      this.snackvar_service.openSnackBar(msg, "", "red-snackbar");
      return;
    }

    this.entryType = this.editorRegistroForm.value;
    this.manageApi(this.entryType, this.mode);
  }

  private getMissingRequiredFieldsLabels(): string[] {
    const labels: string[] = [];

    if (this.editorRegistroForm && this.editorRegistroForm.controls) {
      Object.keys(this.editorRegistroForm.controls).forEach((name) => {
        const ctrl = this.editorRegistroForm.get(name);
        if (ctrl instanceof FormControl && ctrl.errors?.required) {
          labels.push(this.translation?.[name] || name);
        }
      });
    }

    // Complementos (se??o): se o usu?rio apagou todas as linhas, avisar
    if (!this.complementos || this.complementos.length === 0) {
      labels.push(this.translation?.Complementos || "Complementos");
    }

    return Array.from(new Set(labels)).filter(
      (x) => !!x && String(x).trim() !== ""
    );
  }
  get f() {
    return this.editorRegistroForm.controls;
  } //Editor

  manageForm(pkId, mode) {
    if (mode == "I") {
      this.entryType = this.editorRegistroForm.value;
      this.loading = false;
      this.valuedChanged();
      if (this.complementos.length === 0) {
        this.addComplemento();
      }
      //this.changeStatusClientCode(false)
    }
    if (pkId != null) {
      this.findEntryType(pkId);
    }
  }
  findEntryType(pkId) {
    let paginator = {
      page: 1,
      pagelements: 10,
      orderby: "pkId",
      ordertype: "ASC",
    };
    let filters = [{ name: "pkId", value: this.pkId, translation: "", db: "" }];
    this.entryTypeService.getTiposEntradas(paginator, filters).subscribe(
      async (response) => {
        if (response.DatosResult != null) {
          const row = response.DatosResult.Lista[0];
          this.entryType = row;
          this.setValuesForm(row);
          this.recintosAsignados = this.daTiposRecintos(true);
          this.actividadesAsignadas = this.daTiposRecintos(false);
          this.centrosAsignados = this.daTiposCentros();
          this.loadComplementosFromEntryType(this.entryType);

          if (this.taxonomiaActiva && (row.Taxonomia || row.taxonomia)) {
            await this.restaurarTaxonomiaDesdeRegistro(row);
          }

          this._cds.detectChanges();
          const snap: any = { ...row, ...this.editorRegistroForm.getRawValue() };
          snap.Taxonomia = row.Taxonomia ?? row.taxonomia;
          this.entryType = snap as EntryType;
          this.valuedChanged();
          this.initTaxonomiaCabeceraWatch();
          this.loading = false;
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }
  getOrdenRecinto(pkId) {
    let response;
    this.tiposRecinto.forEach((r) => {
      if (r.pkId == pkId) {
        response = this.editorRegistroForm.get(r.pkId).value; // aqui
      }
    });
    return response;
  }
  obtenerRecintosAsociadosconOrden(): string {
    let respuesta: string = "";
    let elemento: string;
    let count = 0;
    if (this.recintosAsignados) {
      this.recintosAsignados.forEach((recinto) => {
        elemento = recinto.pkId + ":" + "0" + ",";
        respuesta = respuesta + elemento;
        count++;
      });
    }
    return respuesta.substring(0, respuesta.length - 1);
  }
  obtenerActividadesAsociadosconOrden(): string {
    let respuesta: string = "";
    let elemento: string;
    let count = 0;
    if (this.actividadesAsignadas) {
      this.actividadesAsignadas.forEach((actividad) => {
        elemento = actividad.pkId + ":" + "0" + ",";
        respuesta = respuesta + elemento;
        count++;
      });
    }
    return respuesta.substring(0, respuesta.length - 1);
  }
  obtenercentrosAsociadosconOrden(): string {
    let respuesta: string = "";
    let elemento: string;
    let count = 0;
    if (this.centrosAsignados) {
      this.centrosAsignados.forEach((centro) => {
        elemento = centro.pkId + ",";
        respuesta = respuesta + elemento;
        count++;
      });
    }
    return respuesta.substring(0, respuesta.length - 1);
  }

  insertDataInObj() {
    const divisaObject = this.servicioAPI.getDivisaObject();
    this.entryType.pkId = this.pkId ? this.pkId : "0";
    this.entryType.DivisaId = divisaObject
      ? divisaObject.pkId
      : localStorage.getItem("DivisaRefId")
        ? localStorage.getItem("DivisaRefId")
        : this.global.divisapordefectoSistema;
    this.entryType.PrecioUnitario = "0"; //Ver Doc Requisitos
    this.entryType.FormatoId = "1"; //Ver Doc Requisitos
    this.entryType.IVA = "0"; //Ver Doc Requisitos
    this.entryType.BaseImponible = "0"; //Ver Doc Requisitos
    this.entryType.MaximoPorDia = "0"; //Ver Doc Requisitos
    this.entryType.TicketVendido = "0"; //Ver Doc Requisitos
    this.entryType.RecintosAsociados = this.obtenerRecintosAsociadosconOrden();
    this.entryType.ActividadesAsociadas =
      this.obtenerActividadesAsociadosconOrden();
    this.entryType.CentrosIds = this.obtenercentrosAsociadosconOrden();
    this.entryType.ALaVenta =
      this.global.aBooleano(this.entryType.ALaVenta) == true ? "1" : "0";
    this.entryType.CodigoBarras =
      this.global.aBooleano(this.entryType.CodigoBarras) == true ? "1" : "0";
    this.entryType.ImprimirTicket =
      this.global.aBooleano(this.entryType.ImprimirTicket) == true ? "1" : "0";
    this.entryType.ImprimirPromoInternet =
      this.global.aBooleano(this.entryType.ImprimirPromoInternet) == true
        ? "1"
        : "0";
    this.entryType.ControlarAcceso =
      this.global.aBooleano(this.entryType.ControlarAcceso) == true ? "1" : "0";
    this.entryType.ImprimirPrecio =
      this.global.aBooleano(this.entryType.ImprimirPrecio) == true ? "1" : "0";
    this.entryType.CuentaVisitante =
      this.global.aBooleano(this.entryType.CuentaVisitante) == true ? "1" : "0";
    this.entryType.BarCodeInternet =
      this.global.aBooleano(this.entryType.BarCodeInternet) == true ? "1" : "0";
    this.entryType.TipoButaca = document
      .getElementsByName("tipoTipoControlButacas")[0]
      .innerText.trim();
    this.entryType.Complementos = this.buildComplementosForRequest();
    const taxonomiaPayload = this.buildTaxonomiaParaInsUpd();
    if (taxonomiaPayload) {
      this.entryType.Taxonomia = taxonomiaPayload;
      /* Evitar duplicar TX no JSON: o form sincroniza cabeçalho nos controls planos
         e buildTaxonomiaParaInsUpd() monta o objeto Taxonomia para a API. */
      this.stripTaxonomiaPlanaDelPayload();
    } else {
      delete (this.entryType as any).Taxonomia;
    }
  }

  /** Remove da raiz os ids de taxonomia já enviados em `Taxonomia`. */
  private stripTaxonomiaPlanaDelPayload(): void {
    const et = this.entryType as unknown as Record<string, unknown>;
    for (const k of EditEntryTypeComponent.TAXONOMIA_KEYS_RAIZ_DUPLICADAS) {
      delete et[k];
    }
  }

  private static readonly TAXONOMIA_KEYS_RAIZ_DUPLICADAS = [
    "TXCentroCosteId",
    "iTXTipoPrecioId",
    "iTXCanalVentasId",
    "TXAlojamientoId",
    "iTXItemVentasId",
    "TXTipoPrecioId",
    "TXCanalVentasId",
    "TXItemVentasId",
  ] as const;
  manageApi(entrytype: EntryType, mode) {
    this.insertDataInObj();
    //this.changeStatusClientCode(true)
    this.loading = true;
    switch (mode) {
      case "I":
        this.entryType.pkId = "0";
        this.InsTiposEntradas(entrytype);
        break;
      case "U":
        //update
        this.entryType.ArgumentosCaracteristica = this.jsonfield.getJSON();
        this.UpdTiposEntradas(entrytype);
        break;
      case "D":
        //duplicate
        this.entryType.pkId = "0";
        this.entryType.ArgumentosCaracteristica = this.jsonfield.getJSON();
        this.InsTiposEntradas(entrytype);
        break;

      default:
        break;
    }
    //this.changeStatusClientCode(false)
  }
  UpdTiposEntradas(tiposentradas) {
    this.entryTypeService
      .insUpdTiposEntradas(tiposentradas, "U")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          this.nextWindow(response);
        },
        (error) => {
          this.loading = false;
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  InsTiposEntradas(tiposentradas) {
    this.entryTypeService
      .insUpdTiposEntradas(tiposentradas, "I")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          this.nextWindow(response);
        },
        (error) => {
          this.loading = false;
          this.httpErrorService.identificarErrores(error);
        }
      );
  }
  insUpdTiposEntradas() {
    this.servicioAPI.insUpdTiposEntradas(this.entryType, this.mode).subscribe(
      (response) => {
        this.save();
        this.destroy();
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }
  /**
   * InsUpdTipoEntrada devolve HTTP 200 com `Mensajes` preenchidos em caso de erro
   * (ex. nome duplicado). Só fechar o painel após sucesso real para não perder o formulário.
   */
  nextWindow(response: any) {
    const mensajes = response?.Mensajes;
    const hayMensajes = Array.isArray(mensajes) && mensajes.length > 0;

    if (hayMensajes) {
      this.loading = false;
      mensajes.forEach((element) => {
        this.snackvar_service.openSnackBar(
          element.DescripcionMensaje,
          "",
          "red-snackbar",
          element.CodigoMensaje
        );
      });
      return;
    }

    this.save();
    this.destroy();
    this.snackvar_service.openSnackBar(
      this.translation["MensajeSuccessSnackBar"],
      "",
      "green-snackbar"
    );
  }
  private stripTaxonomiaMeta(obj: any): any {
    if (!obj || typeof obj !== "object") {
      return obj;
    }
    const { Taxonomia, taxonomia, ...rest } = obj;
    return rest;
  }

  valuedChanged() {
    this.valuedChangedSub?.unsubscribe();
    this.valuedChangedSub = this.editorRegistroForm.valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value) => {
        if (this.entryType != null) {
          this.panelService.setDiscardChanges(false);
          const a = JSON.stringify(this.stripTaxonomiaMeta(value));
          const b = JSON.stringify(this.stripTaxonomiaMeta(this.entryType));
          if (a === b) {
            this.panelService.setDiscardChanges(true);
          }
        }
      });
  }
  generateForm() {
    this.editorRegistroForm = this.formBuilder.group({
      Nombre: ["", [Validators.required, Validators.maxLength(30)]],
      Descripcion: ["", Validators.maxLength(255)],
      TextoPantalla: ["", Validators.maxLength(30)],
      TextoDisplay: ["", Validators.maxLength(30)],
      TextoImpresion: ["", Validators.maxLength(50)],
      TipoAbreviado: ["", Validators.maxLength(15)],
      GrupoId: [""],
      GrupoMotivoId: [""],
      ControlarAcceso: [""],
      CodigoTipoControl: [""],
      ImpresoraSecundaria: [""],
      ALaVenta: [""],
      ImprimirTicket: [""],
      ImprimirPromoInternet: [""],
      CodigoBarras: [""],
      BarCodeInternet: [""],
      ImprimirPrecio: [""],
      TipoButaca: [""],
      CuentaVisitante: [""],
      TeclaRapida: [""],
      TipoProducto: [""],
      TipoVisita: [""],
      TipoPublicoId: [""],
      TipoVisitanteId: [""],
      NivelesId: [""],
      TipoNivel: [""],
      TipoButacaId: [""],
      Categoria: [""],
      TEDDatos: [""],
      GrupoAsociado: [""],
      Complementos: this.formBuilder.array([]),
    });

    const obligatorioCentrosDeCoste = EditEntryTypeComponent.flagActivo(
      localStorage.getItem("ObligatorioCentrosDeCoste")
    );
    const obligatorioCanalesEntradas = EditEntryTypeComponent.flagActivo(
      localStorage.getItem("ObligatorioCanalesEntradas")
    );
    if (this.asociarCentrosCosteCanales) {
      if (obligatorioCentrosDeCoste) {
        this.editorRegistroForm.addControl(
          "CentroCosteId",
          new FormControl("", Validators.required)
        );
      } else {
        this.editorRegistroForm.addControl(
          "CentroCosteId",
          new FormControl("")
        );
      }

      if (obligatorioCanalesEntradas) {
        this.editorRegistroForm.addControl(
          "CanalId",
          new FormControl("", Validators.required)
        );
      } else {
        this.editorRegistroForm.addControl("CanalId", new FormControl(""));
      }
    }

    if (this.taxonomiaActiva) {
      this.editorRegistroForm.addControl(
        "TXCentroCosteId",
        new FormControl(null, Validators.required)
      );
      this.editorRegistroForm.addControl(
        "iTXTipoPrecioId",
        new FormControl(null, Validators.required)
      );
      this.editorRegistroForm.addControl(
        "iTXCanalVentasId",
        new FormControl(null, Validators.required)
      );
      this.editorRegistroForm.addControl("TXAlojamientoId", new FormControl(null));
      this.editorRegistroForm.addControl("iTXItemVentasId", new FormControl(null));
      for (let n = 1; n <= 7; n++) {
        this.editorRegistroForm.addControl(
          `Nivel${n}`,
          new FormControl(
            null,
            n === 1 && this.taxonomiaActiva ? Validators.required : null
          )
        );
      }
    }
  }

  setValuesForm(entryType) {
    this.f["Nombre"].setValue(entryType.Nombre);
    this.f["TipoAbreviado"].setValue(entryType.TipoAbreviado);
    this.f["Descripcion"].setValue(entryType.Descripcion);
    this.f["TextoPantalla"].setValue(entryType.TextoPantalla);
    this.f["TextoDisplay"].setValue(entryType.TextoDisplay);
    this.f["TextoImpresion"].setValue(entryType.TextoImpresion);
    this.f["GrupoMotivoId"].setValue(entryType.GrupoMotivoId);
    this.entryType.GrupoMotivoId = entryType.GrupoMotivoId;

    this.f["ControlarAcceso"].setValue(
      this.global.aBooleano(entryType.ControlarAcceso)
    );
    this.f["CodigoTipoControl"].setValue(entryType.CodigoTipoControl);
    this.entryType.CodigoTipoControl = entryType.CodigoTipoControl;
    this.f["ImpresoraSecundaria"].setValue(entryType.ImpresoraSecundaria);
    this.f["ALaVenta"].setValue(this.global.aBooleano(entryType.ALaVenta));
    this.f["ImprimirTicket"].setValue(
      this.global.aBooleano(entryType.ImprimirTicket)
    );
    this.f["ImprimirPromoInternet"].setValue(
      this.global.aBooleano(entryType.ImprimirPromoInternet)
    );
    this.f["CodigoBarras"].setValue(
      this.global.aBooleano(entryType.CodigoBarras)
    );
    this.f["BarCodeInternet"].setValue(
      this.global.aBooleano(entryType.BarCodeInternet)
    );
    this.f["ImprimirPrecio"].setValue(
      this.global.aBooleano(entryType.ImprimirPrecio)
    );
    this.f["TipoButaca"].setValue(entryType.TipoButaca);
    this.f["CuentaVisitante"].setValue(
      this.global.aBooleano(entryType.CuentaVisitante)
    );
    this.f["TeclaRapida"].setValue(entryType.TeclaRapida);
    this.f["GrupoId"].setValue(entryType.GrupoId);
    this.entryType.GrupoId = entryType.GrupoId;
    this.f["TipoProducto"].setValue(entryType.TipoProducto);
    this.entryType.TipoProducto = entryType.TipoProducto;
    this.f["GrupoAsociado"].setValue(entryType.GrupoAsociado);
    this.entryType.GrupoAsociado = entryType.GrupoAsociado;
    this.f["TipoVisita"].setValue(entryType.TipoVisita);
    this.f["TipoPublicoId"].setValue(entryType.TipoPublicoId);
    this.f["TipoVisitanteId"].setValue(entryType.TipoVisitanteId);
    this.f["NivelesId"].setValue(entryType.NivelesId);
    this.entryType.TipoVisita = entryType.TipoVisita;
    this.f["TipoNivel"].setValue(entryType.TipoNivel);
    this.entryType.TipoNivel = entryType.TipoNivel;
    this.f["TipoButacaId"].setValue(entryType.TipoButacaId);
    this.entryType.TipoButacaId = entryType.TipoButacaId;

    this.f["Categoria"].setValue(entryType.Categoria);
    this.entryType.Categoria = entryType.Categoria;
    this.f["TEDDatos"].setValue(entryType.TEDatos);
    this.entryType.TEDDatos = entryType.TEDatos;
    if (this.editorRegistroForm.get("CentroCosteId")) {
      this.f["CentroCosteId"].setValue(entryType.CentroCosteId);
      this.entryType.CentroCosteId = entryType.CentroCosteId;
    }
    if (this.editorRegistroForm.get("CanalId")) {
      this.f["CanalId"].setValue(entryType.CanalId);
      this.entryType.CanalId = entryType.CanalId;
    }

    if (this.taxonomiaActiva) {
      const txFlat = this.taxonomiaPlanaDesdeRegistro(entryType);
      this.editorRegistroForm.patchValue(
        {
          TXCentroCosteId: txFlat.TXCentroCosteId,
          iTXTipoPrecioId: txFlat.iTXTipoPrecioId,
          iTXCanalVentasId: txFlat.iTXCanalVentasId,
          TXAlojamientoId: txFlat.TXAlojamientoId,
          iTXItemVentasId: txFlat.iTXItemVentasId,
        },
        { emitEvent: false }
      );
    }

    if (this.jsonfield) {
      const argumentos =
        entryType.ArgumentosCaracteristica &&
        entryType.ArgumentosCaracteristica.trim() !== ""
          ? entryType.ArgumentosCaracteristica
          : this.myJSON;
      this.jsonfield.setJSON(argumentos);
      this.jsonfield.refresh();
    }

    this._cds.detectChanges();
  }

  get complementos(): FormArray {
    return this.editorRegistroForm.get("Complementos") as FormArray;
  }

  createComplementoGroup(data?: {
    ComplementoId?: string;
    Opcion?: string;
    Cantidad?: string;
  }): FormGroup {
    const group = this.formBuilder.group({
      ComplementoId: [data && data.ComplementoId ? data.ComplementoId : ""],
      Opcion: [data && data.Opcion ? data.Opcion : ""],
      Cantidad: [
        data && data.Cantidad ? data.Cantidad : "0",
        [Validators.pattern("^[0-9]+$"), Validators.min(0), Validators.maxLength(5)],
      ],
    });

    // Regra: ou a linha est? "limpa" (sem complemento/op??o e quantidade 0),
    // ou est? totalmente preenchida (complemento + op??o + quantidade >= 1).
    group.valueChanges.subscribe(() => this.validateComplementoRow(group));
    // validar estado inicial (carregado da API ou default)
    this.validateComplementoRow(group);

    return group;
  }

  private validateComplementoRow(group: FormGroup): void {
    const complementoId = (group.get("ComplementoId")?.value || "").toString().trim();
    const opcion = (group.get("Opcion")?.value || "").toString().trim();
    const cantidadRaw = group.get("Cantidad")?.value;
    const cantidadNum = Number.parseInt(
      (cantidadRaw ?? "0").toString(),
      10
    );

    const hasComplemento = complementoId !== "";
    const hasOpcion = opcion !== "";
    const hasCantidad = Number.isFinite(cantidadNum) && cantidadNum > 0;

    const anyFilled = hasComplemento || hasOpcion || hasCantidad;

    const setReq = (controlName: "ComplementoId" | "Opcion" | "Cantidad", on: boolean) => {
      const ctrl = group.get(controlName);
      if (!ctrl) return;
      const current = ctrl.errors || {};
      if (on) {
        if (!current["required"]) {
          ctrl.setErrors({ ...current, required: true });
        }
      } else if (current["required"]) {
        const { required, ...rest } = current as any;
        ctrl.setErrors(Object.keys(rest).length ? rest : null);
      }
    };

    if (!anyFilled) {
      setReq("ComplementoId", false);
      setReq("Opcion", false);
      setReq("Cantidad", false);
      return;
    }

    setReq("ComplementoId", !hasComplemento);
    setReq("Opcion", !hasOpcion);
    setReq("Cantidad", !hasCantidad);
  }

  addComplemento(data?: {
    ComplementoId?: string;
    Opcion?: string;
    Cantidad?: string;
  }) {
    this.complementos.push(this.createComplementoGroup(data));
  }

  removeComplemento(index: number) {
    if (this.complementos.length > 1) {
      this.complementos.removeAt(index);
    } else {
      // Quando s? h? um complemento, resetamos a linha para o estado "novo"
      const group = this.complementos.at(index) as FormGroup;
      if (group) {
        group.patchValue({
          ComplementoId: "",
          Opcion: "",
          Cantidad: "0",
        });
        group.markAsPristine();
        group.markAsUntouched();
      }

      const compleMethods = this.complementoMethods[index];
      if (compleMethods && typeof compleMethods.setManualValueForm === "function") {
        compleMethods.setManualValueForm("");
      }

      const opcMethods = this.opcionMethods[index];
      if (opcMethods && typeof opcMethods.setManualValueForm === "function") {
        opcMethods.setManualValueForm("");
      }
    }
  }

  private loadComplementosFromEntryType(entryType: EntryType) {
    this.complementos.clear();
    if (entryType && entryType.Complementos && entryType.Complementos.length) {
      entryType.Complementos.forEach((c) => {
        this.addComplemento({
          ComplementoId: c.ComplementoId,
          Opcion: c.Opcion,
          Cantidad: c.Cantidad,
        });
      });
    } else {
      this.addComplemento();
    }
  }

  private buildComplementosForRequest(): Array<{
    ComplementoId: string;
    Opcion: string;
    Cantidad: string;
  }> {
    const valores: any[] = this.complementos.value || [];
    const limpios = valores.filter((c) => {
      const cantidadNum = Number.parseInt((c?.Cantidad ?? "0").toString(), 10);
      const hasCantidad = Number.isFinite(cantidadNum) && cantidadNum > 0;
      const hasAny =
        (c.ComplementoId && c.ComplementoId.toString().trim() !== "") ||
        (c.Opcion && c.Opcion.toString().trim() !== "") ||
        hasCantidad;
      return hasAny;
    });
    // S? envia linhas completas (Complemento + Op??o + Cantidad >= 1)
    return limpios
      .filter((c) => {
        const cantidadNum = Number.parseInt((c?.Cantidad ?? "0").toString(), 10);
        const hasCantidad = Number.isFinite(cantidadNum) && cantidadNum > 0;
        const hasComplemento =
          c?.ComplementoId && c.ComplementoId.toString().trim() !== "";
        const hasOpcion = c?.Opcion && c.Opcion.toString().trim() !== "";
        return hasComplemento && hasOpcion && hasCantidad;
      })
      .map((c) => ({
        ComplementoId: c.ComplementoId,
        Opcion: c.Opcion,
        Cantidad: c.Cantidad,
      }));
  }

  onComplementoInputClose(event: {
    name: string;
    value: string;
    methods?: any;
  }): void {
    if (!event || !event.name) {
      return;
    }

    const parts = event.name.split("_");
    if (parts.length !== 2) {
      return;
    }

    const field = parts[0];
    const index = parseInt(parts[1], 10);

    if (isNaN(index) || index < 0 || index >= this.complementos.length) {
      return;
    }

    const row = this.complementos.at(index) as FormGroup;
    if (!row) {
      return;
    }

    const rawValue = event.value;
    const value = rawValue === "-1" ? "" : rawValue;

    switch (field) {
      case "ComplementoId":
        if (event.methods) {
          this.complementoMethods[index] = event.methods;
        }
        row.get("ComplementoId")?.setValue(value);
        break;
      case "Opcion":
        if (event.methods) {
          this.opcionMethods[index] = event.methods;
        }
        row.get("Opcion")?.setValue(value);
        break;
      default:
        break;
    }
  }

  getComplementoDisplay(complementoId: string): string {
    if (!complementoId) {
      return this.translation.Complementos;
    }

    const complemento = this.complementosDisponibles.find(
      (item) => item.pkId == complementoId
    );

    return complemento ? complemento.Nombre : this.translation.Complementos;
  }

  getOpcionDisplay(opcion: string): string {
    if (!opcion) {
      return this.translation.Opciones;
    }

    if (opcion == "1") {
      return this.translation.Desglosar || this.translation.Desglose || "Desglose";
    }

    if (opcion == "2") {
      return this.translation.Imprimir;
    }

    return this.translation.Opciones;
  }

  cambiaNombre(evento) {
    //Si los modelos de Display, Taquilla y Imprimir estan vacios les pongo el Nombre del evento.

    if (
      this.f["TextoDisplay"].value == null ||
      this.f["TextoDisplay"].value.trim() == ""
    ) {
      this.f["TextoDisplay"].setValue(evento.target.value);
    }
    if (
      this.f["TextoPantalla"].value == null ||
      this.f["TextoPantalla"].value.trim() == ""
    ) {
      this.f["TextoPantalla"].setValue(evento.target.value);
    }
    if (
      this.f["TextoImpresion"].value == null ||
      this.f["TextoImpresion"].value.trim() == ""
    ) {
      this.f["TextoImpresion"].setValue(evento.target.value);
    }
  }
  comparaObjetosSelect(o1: any, o2: any) {
    return o1 && o2
      ? o1.id === o2.id || o1 === o2.id || o1.id === o2
      : o1 === o2;
  }
  asignarTipoCentro(item, evento) {
    this.centrosasociados.push(item.pkId);
  }
  desasignarTipoCentro(item, evento) {
    let arrtemp = [];
    arrtemp = this.centrosasociados.filter(function (x) {
      return x != item.pkId;
    });
    this.centrosasociados = arrtemp;
  }

  filtrarTiposCentros() {
    if (!this.tipoCentros || !this.tipoCentros.length) {
      return [];
    }
    // return this.tipoCentros.filter(x => x.Activo == "True");
    let respuesta = [];
    let Centros = this.tipoCentros.filter((x) => x.Activo == "True");
    let tmpCentrosAsociados = this.centrosasociados;
    if (Centros != null && Centros.length > 0) {
      respuesta = Centros.filter(function (item) {
        return (
          tmpCentrosAsociados.findIndex(function (itemSub) {
            return itemSub == item.pkId;
          }) === -1
        );
      });
    } else {
      respuesta = this.tipoCentros.filter((x) => x.Activo == "True");
    }
    return respuesta;
  }

  deasignarTodosCentros() {
    this.centrosasociados = [];
  }
  asignarTodosCentros() {
    this.centrosasociados = this.tipoCentros
      .filter((x) => x.Activo == "True")
      .map(function (x) {
        return x.pkId;
      });
  }

  daTiposCentros(): any[] {
    let respuesta = [];
    if (this.tipoCentros != null && this.entryType?.CentrosIds) {
      let arrayCentrosString = this.entryType.CentrosIds.split(",");
      let arrayCentros = [];
      arrayCentrosString.map((asociado) => {
        let asociadoCopy = asociado.split(":");
        arrayCentros.push(asociadoCopy);
      });

      let allCentros = this.tipoCentros.filter((x) => x.Activo == "True");

      arrayCentros.map((recinto) => {
        let act = allCentros.find((find) => find.pkId == recinto[0]);
        respuesta.push(act);
      });
    }

    return respuesta;
  }

  //True = recinto, false = Actividad
  filtrarTiposRecintos(tipo?: boolean): any[] {
    let respuesta = [];

    if (tipo != null && this.tiposRecinto != null) {
      if (tipo) {
        let Recintos = this.tiposRecinto.filter((x) => x.Taller != "1");
        let tmpRecintosAsociados = this.recintosasignados;
        if (Recintos != null && Recintos.length > 0) {
          respuesta = Recintos.filter(function (item) {
            return (
              tmpRecintosAsociados.findIndex(function (itemSub) {
                return itemSub == item.pkId;
              }) === -1
            );
          });
        } else {
          respuesta = this.tiposRecinto;
        }
      } else {
        let Talleres = this.tiposRecinto.filter((x) => x.Taller == "1");
        let tmpActividadesAsociadas = this.actividadesasociadas;
        if (Talleres != null && Talleres.length > 0) {
          respuesta = Talleres.filter(function (item) {
            return (
              tmpActividadesAsociadas.findIndex(function (itemSub) {
                return itemSub == item.pkId;
              }) === -1
            );
          });
        } else {
          respuesta = this.tiposRecinto;
        }
      }
    }
    return respuesta;
  }

  deasignarTodasActividades() {
    this.actividadesasociadas = [];
  }
  asignarTodasActividades() {
    this.actividadesasociadas = this.tiposRecinto
      .filter((x) => x.Taller == "1")
      .map(function (x) {
        return x.pkId;
      });
  }
  //---Asignacion Actividades
  asignarTipoActividad(item, evento) {
    this.actividadesasociadas.push(item.pkId);
  }
  desasignarTipoActividad(item, evento) {
    let arrtemp = [];
    arrtemp = this.actividadesasociadas.filter(function (x) {
      return x != item.pkId;
    });
    this.actividadesasociadas = arrtemp;
  }

  //True = recinto, false = Actividad heree
  daTiposRecintos(tipo?: boolean): any[] {
    let respuesta = [];

    if (tipo != null && this.tiposRecinto != null) {
      if (tipo) {
        if (this.entryType.RecintosAsociados) {
          let arrayRecintosString = this.entryType.RecintosAsociados.split(",");
          let arrayRecintos = [];
          arrayRecintosString.map((asociado) => {
            let asociadoCopy = asociado.split(":");
            arrayRecintos.push(asociadoCopy);
          });
          let allRecintos = this.tiposRecinto.filter((x) => x.Taller != "1");

          let array = arrayRecintos.map((recinto) => {
            let act = allRecintos.find((find) => find.pkId == recinto[0]);
            respuesta.push(act);
          });
        }
      } else {
        if (this.entryType.ActividadesAsociadas) {
          let arrayAsociadosString =
            this.entryType.ActividadesAsociadas.split(",");
          let arrayAsociados = [];
          arrayAsociadosString.map((asociado) => {
            let asociadoCopy = asociado.split(":");
            arrayAsociados.push(asociadoCopy);
          });

          let allAsociados = this.tiposRecinto.filter((x) => x.Taller == "1");
          arrayAsociados.map((asociado) => {
            let act = allAsociados.find((find) => find.pkId == asociado[0]);
            respuesta.push(act);
          });
        }
      }
    }
    return respuesta;
  }

  //---Asignacion Recintos
  asignarTipoRecinto(item, evento) {
    this.recintosasignados.push(item.pkId);
    this.ordenRecintosAsociados.push(null);
  }

  desasignarTipoRecinto(item, evento) {
    let arrtemp = [];
    let index = this.recintosasignados.indexOf(item.pkId);
    if (index >= 0) {
      this.ordenRecintosAsociados.splice(index, 1);
    }
    arrtemp = this.recintosasignados.filter(function (x) {
      return x != item.pkId;
    });
    this.recintosasignados = arrtemp;
  }

  deasignarTodosRecintos() {
    this.recintosasignados = [];
    this.ordenRecintosAsociados = [];
  }
  asignarTodosRecintos() {
    // Coger los Ordenes Actuales y ponerlos en el nuevo array
    let numItem: number = 0;
    let tmpElementos: { idRecinto: string; orden: string }[] = [];
    this.ordenRecintosAsociados.forEach((element) => {
      if (element != null && element.trim() != "") {
        tmpElementos.push({
          idRecinto: this.recintosasignados[numItem],
          orden: element,
        });
      }
      numItem++;
    });
    //cargamos todos
    this.recintosasignados = this.tiposRecinto
      .filter((x) => x.Taller != "1")
      .map(function (x) {
        return x.pkId;
      });
    this.ordenRecintosAsociados = [];
    //Repasamos para poner los ordenes correctos y lo demas a null
    this.recintosasignados.forEach((element) => {
      let tmpIndex = tmpElementos.findIndex((y) => y.idRecinto == element);
      if (tmpIndex >= 0) {
        this.ordenRecintosAsociados.push(tmpElementos[tmpIndex].orden);
      } else {
        this.ordenRecintosAsociados.push(null);
      }
    });
  }

  validacion() {
    const separador = document.getElementsByClassName("separadorLateral");
    const campos = document.getElementsByClassName("editor-campo-registro");
    for (let i = 0; i < campos.length; i++) {
      if (campos[i].classList.contains("ng-valid")) {
        if (campos[i].classList.contains("editor-campo-registro-check")) {
          separador[i].setAttribute("style", "border-color:#002c76");
        } else {
          separador[i].setAttribute("style", "border-color:green");
        }
      } else {
        separador[i].setAttribute("style", "border-color:#002c76");
      }
    }
  }
  async cargarBotonera(): Promise<boolean> {
    let resultado: boolean = false;
    await this.entryTypeService
      .getBotoneraAsync(
        null,
        this.global.maxBotonesRapidosTPV.toString().trim()
      )
      .then(
        (data) => {
          if (data.DatosResult != null) {
            this.tiposBotoneraEntrada = data.DatosResult.Lista;
          } else {
            this.alertaServicio.error(
              "Botonera: " + data.Mensajes[0].DescripcionMensaje
            );
            resultado = false;
          }
        },
        (error) => {
          //this.alertaServicio.error('Botonera: ' + error);
          this.httpErrorService.identificarErrores(error);
          resultado = false;
        }
      );
    return resultado;
  }
  createOrderFormFields() {
    this.tiposRecinto.forEach((r) => {
      this.editorRegistroForm.addControl(r.pkId, new FormControl(""));
    });
  }
  async cargarDatosAsync(): Promise<boolean> {
    //Cargamos Datos
    let resultado: boolean = false;

    this.entryTypeService.GetTiposEntradaDatos().subscribe(
      (data) => {
        this.TiposEntradaDatosAPI = data;
        this.tiposEntradaDatos = [];
        if (this.TiposEntradaDatosAPI.DatosResult != null) {
          if (
            this.TiposEntradaDatosAPI.DatosResult.ListadoTiposEntradaDatos !=
            null
          ) {
            this.TiposEntradaDatosAPI.DatosResult.ListadoTiposEntradaDatos.forEach(
              (element) => {
                this.tiposEntradaDatos.push(element);
              }
            );
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.entryTypeService.GetGruposAsociados().subscribe(
      (data) => {
        this.GruposAsociadosAPI = data;
        this.gruposAsociadosDatos = [];
        if (this.GruposAsociadosAPI.DatosResult != null) {
          if (
            this.GruposAsociadosAPI.DatosResult.ListadoGruposAsociados != null
          ) {
            this.GruposAsociadosAPI.DatosResult.ListadoGruposAsociados.forEach(
              (element) => {
                this.gruposAsociadosDatos.push(element);
              }
            );
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.entryTypeService.GetTiposNiveles().subscribe(
      (data) => {
        this.TiposNivelesAPI = data;
        this.tiposNivelesDatos = [];
        if (this.TiposNivelesAPI.DatosResult != null) {
          if (this.TiposNivelesAPI.DatosResult.ListadoTiposNiveles != null) {
            this.TiposNivelesAPI.DatosResult.ListadoTiposNiveles.forEach(
              (element) => {
                this.tiposNivelesDatos.push(element);
              }
            );
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.entryTypeService.GetTiposProductos().subscribe(
      (data) => {
        this.TiposProductosAPI = data;
        this.tiposProductosDatos = [];
        if (this.TiposProductosAPI.DatosResult != null) {
          if (
            this.TiposProductosAPI.DatosResult.ListadoTiposProductos != null
          ) {
            this.TiposProductosAPI.DatosResult.ListadoTiposProductos.forEach(
              (element) => {
                this.tiposProductosDatos.push(element);
              }
            );
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.entryTypeService.ObtenerCustomanTipoVisita().subscribe(
      (data) => {
        this.TipoVisitaAPI = data;
        this.tipoVisitaDatos = [];
        if (this.TipoVisitaAPI.DatosResult != null) {
          if (this.TipoVisitaAPI.DatosResult.lista != null) {
            this.TipoVisitaAPI.DatosResult.lista.forEach((element) => {
              this.tipoVisitaDatos.push(element);
            });
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.entryTypeService.ObtenerCustomanTipoPublico().subscribe(
      (data) => {
        this.TipoPublicoAPI = data;
        this.tipoPublicoDatos = [];
        if (this.TipoPublicoAPI.DatosResult != null) {
          if (this.TipoPublicoAPI.DatosResult.lista != null) {
            this.TipoPublicoAPI.DatosResult.lista.forEach((element) => {
              this.tipoPublicoDatos.push(element);
            });
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.entryTypeService.ObtenerCustomanTipoVisitante().subscribe(
      (data) => {
        this.TipoVisitanteAPI = data;
        this.tipoVisitanteDatos = [];
        if (this.TipoVisitanteAPI.DatosResult != null) {
          if (this.TipoVisitanteAPI.DatosResult.lista != null) {
            this.TipoVisitanteAPI.DatosResult.lista.forEach((element) => {
              this.tipoVisitanteDatos.push(element);
            });
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.entryTypeService.ObtenerCustomanNivel().subscribe(
      (data) => {
        this.NivelAPI = data;
        this.NivelDatos = [];
        if (this.NivelAPI.DatosResult != null) {
          if (this.NivelAPI.DatosResult.lista != null) {
            this.NivelAPI.DatosResult.lista.forEach((element) => {
              this.NivelDatos.push(element);
            });
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.entryTypeService.ObtenerCustomanCategoria().subscribe(
      (data) => {
        this.CategoriaAPI = data;
        this.categoriaDatos = [];
        if (this.CategoriaAPI.DatosResult != null) {
          if (this.CategoriaAPI.DatosResult.lista != null) {
            this.CategoriaAPI.DatosResult.lista.forEach((element) => {
              this.categoriaDatos.push(element);
            });
          }
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    if (this.asociarCentrosCosteCanales) {
      this.entryTypeService.ObtenerCustomanCentroCoste().subscribe(
        (data) => {
          this.CentroCosteAPI = data;
          this.centroCosteDatos = [];
          if (this.CentroCosteAPI.DatosResult != null) {
            if (this.CentroCosteAPI.DatosResult.Lista != null) {
              this.CentroCosteAPI.DatosResult.Lista.forEach((element) => {
                this.centroCosteDatos.push(element);
              });
            }
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );

      this.entryTypeService.ObtenerCustomanCanalesSub().subscribe(
        (data) => {
          this.CanalesAPI = data;
          this.canalesDatos = [];
          if (this.CanalesAPI.DatosResult != null) {
            if (this.CanalesAPI.DatosResult.Lista != null) {
              this.CanalesAPI.DatosResult.Lista.forEach((element) => {
                if (element.Seleccionable == "1") this.canalesDatos.push(element);
              });
            }
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
    } else {
      this.centroCosteDatos = [];
      this.canalesDatos = [];
    }

    if (this.asociarCentros) {
      this.entryTypeService.getCentros().subscribe(
        (data) => {
          this.CentrosAPI = data;
          this.tipoCentros = [];
          if (this.CentrosAPI.DatosResult != null) {
            if (this.CentrosAPI.DatosResult.ListaCentros != null) {
              this.tipoCentros = this.CentrosAPI.DatosResult.ListaCentros;
            }
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
    } else {
      this.tipoCentros = [];
    }

    this.entryTypeService.GetComplementos().subscribe(
      (data) => {
        this.complementosDisponibles = [];
        if (data && data.DatosResult && data.DatosResult.Lista) {
          this.complementosDisponibles = data.DatosResult.Lista;
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    await this.entryTypeService.getTiposControlAsync().then(
      (data) => {
        if (data.DatosResult != null) {
          this.tiposTiposControl = data.DatosResult.customanTiposControl;
        } else {
          this.alertaServicio.error(data.Mensajes[0].DescripcionMensaje);
          resultado = false;
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );
    //Lanzamos encadenado
    await this.entryTypeService.getGruposTiposEntradaAsync().then(
      (data) => {
        if (data.DatosResult != null) {
          this.tiposGrupoTipoEntrada =
            data.DatosResult.customanGrupoTipoEntrada;
          this.tiposGrupoTipoEntradaSinMotivo =
            data.DatosResult.customanGrupoTipoEntrada.filter(
              (x) => x.ConMotivo == "0"
            );
          this.tiposGrupoTipoEntradaMotivo =
            data.DatosResult.customanGrupoTipoEntrada.filter(
              (x) => x.ConMotivo == "1"
            );
        } else {
          //this.alertaServicio.error(this.tiposGruposActividadesAPI.Mensajes[0].DescripcionMensaje);
          this.tiposGrupoTipoEntrada = [];
          this.tiposGrupoTipoEntradaSinMotivo = [];
          this.tiposGrupoTipoEntradaMotivo = [];
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );
    //Lanzamos encadenado
    await this.entryTypeService.getRecintosAsync().then(
      (data) => {
        if (data.DatosResult != null) {
          this.tiposRecinto = data.DatosResult.ListaRecintos;
          //this.createOrderFormFields();
        } else {
          this.tiposRecinto = [];
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );
    //Lanzamos encadenado
    await this.entryTypeService.getTiposButacaAsync().then(
      (data) => {
        if (data.DatosResult != null) {
          this.tiposTiposButaca = data.DatosResult.DatosListas;
        } else {
          this.tiposTiposButaca = [];
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );
    await this.cargarTaxonomiaLists();
    this.cargarBotonera();
    this.manageForm(this.pkId, this.mode);
    this.recintosSinAsignar = this.filtrarTiposRecintos(true);
    this.actividadesSinAsignar = this.filtrarTiposRecintos(false);
    this.centrosSinAsignar = this.filtrarTiposCentros();

    if (
      this.taxonomiaActiva &&
      (this.mode === "I" || this.pkId == null || this.pkId === "")
    ) {
      this.initTaxonomiaCabeceraWatch();
    }

    return resultado;
  }

  private textoCuentaVisitanteInformativo(cv: any): string {
    if (cv === null || cv === undefined) {
      return "";
    }
    if (typeof cv === "string" && cv.trim() === "") {
      return "";
    }
    const n =
      typeof cv === "number" ? cv : parseInt(String(cv).trim(), 10);
    if (Number.isNaN(n) || n <= -1) {
      return "";
    }
    if (n === 0) {
      return this.translation?.No ?? "No";
    }
    if (n === 1) {
      return this.translation?.Si ?? "Si";
    }
    return "";
  }

  get mostrarTaxonomiaInfo(): boolean {
    return !!(this.taxonomiaRevenueCategory || this.mostrarCuentaVisitante);
  }

  get mostrarCuentaVisitante(): boolean {
    return !!this.taxonomiaCuentaVisitante;
  }

  /** Desplaza el panel hasta Revenue / Cuenta visitante tras elegir hoja (último nivel). */
  private scrollTaxonomiaInfoIntoView(): void {
    this._cds.detectChanges();
    const scroll = (): void => {
      const el = this.taxonomiaInfoFooter?.nativeElement;
      if (el && this.mostrarTaxonomiaInfo) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }
    };
    setTimeout(scroll, 0);
    setTimeout(scroll, 120);
  }

  /**
   * Tras cargar un nivel hijo, desplaza la vista para que el nuevo selector no quede
   * oculto bajo el pie (pantallas pequeñas).
   */
  private scrollTaxonomiaNivelesAnchorIntoView(): void {
    this._cds.detectChanges();
    const scroll = (): void => {
      const el = this.taxonomiaNivelesAnchor?.nativeElement;
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    };
    setTimeout(scroll, 0);
    setTimeout(scroll, 160);
  }

  compareNivelTx(o1: any, o2: any): boolean {
    if (o1 === o2) return true;
    if (!o1 || !o2) return false;
    const id1 = o1.TXItemVentasId ?? o1.pkId;
    const id2 = o2.TXItemVentasId ?? o2.pkId;
    if (id1 != null && id2 != null && String(id1) === String(id2)) {
      return true;
    }
    const n1 = (o1.NivelNombre ?? "").toString().trim();
    const n2 = (o2.NivelNombre ?? "").toString().trim();
    return n1 !== "" && n1 === n2;
  }

  validateFields(field: string): boolean {
    const ctrl = this.editorRegistroForm.get(field);
    return !!(ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched));
  }

  /** Mesmo padrão Customman que `app-input-filter`: * + CampoRequerido. */
  get textoCampoRequerido(): string {
    const t = this.translation;
    return (
      (t && (t["CampoRequerido"] || t["CampoObligatorio"])) || "Campo requerido"
    );
  }

  private taxonomiaPlanaDesdeRegistro(reg: any): {
    TXCentroCosteId: any;
    iTXTipoPrecioId: any;
    iTXCanalVentasId: any;
    iTXItemVentasId: any;
    TXAlojamientoId: any;
  } {
    const t = reg?.Taxonomia ?? reg?.taxonomia;
    if (t && typeof t === "object") {
      return {
        TXCentroCosteId: t.TXCentroCosteId ?? reg.TXCentroCosteId ?? null,
        iTXTipoPrecioId:
          t.iTXTipoPrecioId ??
          t.TXTipoPrecioId ??
          reg.iTXTipoPrecioId ??
          reg.TXTipoPrecioId ??
          null,
        iTXCanalVentasId:
          t.iTXCanalVentasId ??
          t.TXCanalVentasId ??
          reg.iTXCanalVentasId ??
          reg.TXCanalVentasId ??
          null,
        iTXItemVentasId:
          t.TXItemVentasId ?? t.iTXItemVentasId ?? reg.iTXItemVentasId ?? null,
        TXAlojamientoId:
          t.TXAlojamientoId ?? reg.TXAlojamientoId ?? null,
      };
    }
    return {
      TXCentroCosteId: reg.TXCentroCosteId ?? null,
      iTXTipoPrecioId: reg.iTXTipoPrecioId ?? reg.TXTipoPrecioId ?? null,
      iTXCanalVentasId: reg.iTXCanalVentasId ?? reg.TXCanalVentasId ?? null,
      iTXItemVentasId: reg.iTXItemVentasId ?? reg.TXItemVentasId ?? null,
      TXAlojamientoId: reg.TXAlojamientoId ?? null,
    };
  }

  private async restaurarTaxonomiaTrasDescartar(reg: any): Promise<void> {
    const t = reg?.Taxonomia ?? reg?.taxonomia;
    if (!this.taxonomiaActiva || !t || typeof t !== "object") {
      return;
    }
    await this.restaurarTaxonomiaDesdeRegistro(reg);
  }

  private async cargarTaxonomiaLists(): Promise<void> {
    if (!this.taxonomiaActiva) {
      return;
    }
    try {
      const [centroCoste, tipoPrecio, canalVentas, alojamiento] =
        await Promise.all([
          this.servicioAPI.TraerDatosListasAsync("txcentrocoste" as any).toPromise(),
          this.servicioAPI.TraerDatosListasAsync("txtipoprecio" as any).toPromise(),
          this.servicioAPI
            .TraerDatosListasAsync("txcanalventa" as any, {
              NombreCampo: "activo" as any,
              FiltroCampo: "1",
            } as any)
            .toPromise(),
          this.servicioAPI.TraerDatosListasAsync("txalojamiento" as any).toPromise(),
        ]);
      this.txCentroCoste = (centroCoste?.DatosListas ?? []).map((x: any) => ({
        ...x,
        pkId: x.pkId ?? x.Id,
        No: x.No ?? x.pkId ?? x.Id,
        Nombre: x.Nombre ?? x.chCentroCosteTX ?? "",
      }));
      this.txTipoPrecio = (tipoPrecio?.DatosListas ?? []).map((x: any) => ({
        ...x,
        pkId: x.pkId ?? x.Id,
        Nombre: x.Nombre ?? x.chTipoPrecioTX ?? "",
      }));
      this.txCanalVentas = (canalVentas?.DatosListas ?? []).map((x: any) => ({
        ...x,
        pkId: x.pkId ?? x.Id,
        Nombre: x.Nombre ?? x.chCanalVentasTX ?? "",
      }));
      this.txAlojamiento = (alojamiento?.DatosListas ?? []).map((x: any) => ({
        ...x,
        pkId: x.pkId ?? x.Id,
        Nombre: x.Nombre ?? x.chAlojamientoTX ?? x.Nombre ?? "",
      }));
      await this.cargarNivelTaxonomia(1);
    } catch (error) {
      this.httpErrorService.identificarErrores(error);
    }
  }

  async cargarNivelTaxonomia(
    nivel: number,
    nivelPredecesorNombre?: string,
    options?: { refreshView?: boolean }
  ): Promise<void> {
    const refreshView = options?.refreshView !== false;
    try {
      const hdr = this.taxonomiaActiva
        ? this.editorRegistroForm.getRawValue()
        : null;
      const taxonomiaCabecera =
        hdr &&
        (hdr.TXCentroCosteId ||
          hdr.iTXTipoPrecioId ||
          hdr.iTXCanalVentasId)
          ? {
              TXCentroCosteId: hdr.TXCentroCosteId,
              TXTipoPrecioId: hdr.iTXTipoPrecioId,
              TXCanalVentasId: hdr.iTXCanalVentasId,
            }
          : undefined;
      const data = await this.servicioAPI
        .GetTXItemVentasSegunNivel(
          nivel,
          nivelPredecesorNombre,
          taxonomiaCabecera
        )
        .toPromise();
      const listado =
        data?.DatosResult?.Listado ?? data?.DatosResult?.Lista ?? [];
      this.txNiveles[nivel] = listado;
      if (listado?.length && this.taxonomiaActiva) {
        this.actualizarValidadorNivel(nivel, true);
      }
      if (refreshView) {
        this._cds.detectChanges();
      }
    } catch (error) {
      this.txNiveles[nivel] = [];
      this.actualizarValidadorNivel(nivel, false);
      this.httpErrorService.identificarErrores(error);
      if (refreshView) {
        this._cds.detectChanges();
      }
    }
  }

  onNivelTaxonomiaChange(nivel: number, item: any): void {
    for (let n = nivel + 1; n <= 7; n++) {
      this.editorRegistroForm.get(`Nivel${n}`)?.setValue(null);
      this.txNiveles[n] = [];
      this.actualizarValidadorNivel(n, false);
    }
    this.taxonomiaRevenueCategory = "";
    this.taxonomiaCuentaVisitante = "";
    this.ultimoNivelTaxonomiaLeaf = null;
    if (item && (item.TieneSucesor === 0 || item.TieneSucesor === "0")) {
      this.ultimoNivelTaxonomiaLeaf = item;
      this.taxonomiaRevenueCategory = item.RevenueCategory ?? "";
      this.taxonomiaCuentaVisitante = this.textoCuentaVisitanteInformativo(
        item.CuentaVisitante
      );
      const patch: Record<string, unknown> = {
        iTXItemVentasId: item.TXItemVentasId ?? item.pkId,
      };
      const cv = EditEntryTypeComponent.idTaxonomiaDesdeNodoIfAny(item, [
        "TXCanalVentasId",
        "iTXCanalVentasId",
        "CanalVentasId",
        "CanalVentaId",
      ]);
      if (cv) {
        patch.iTXCanalVentasId = cv;
      }
      const tp = EditEntryTypeComponent.idTaxonomiaDesdeNodoIfAny(item, [
        "TXTipoPrecioId",
        "iTXTipoPrecioId",
      ]);
      if (tp) {
        patch.iTXTipoPrecioId = tp;
      }
      const cc = EditEntryTypeComponent.idTaxonomiaDesdeNodoIfAny(item, [
        "TXCentroCosteId",
      ]);
      if (cc) {
        patch.TXCentroCosteId = cc;
      }
      this.editorRegistroForm.patchValue(patch, { emitEvent: false });
      this._cds.detectChanges();
      this.scrollTaxonomiaInfoIntoView();
    } else if (item) {
      this.actualizarValidadorNivel(nivel + 1, true);
      void this.cargarNivelTaxonomia(nivel + 1, item.NivelNombre).then(() => {
        this.scrollTaxonomiaNivelesAnchorIntoView();
      });
      this._cds.detectChanges();
    } else {
      this._cds.detectChanges();
    }
  }

  private actualizarValidadorNivel(nivel: number, required: boolean): void {
    const ctrl = this.editorRegistroForm.get(`Nivel${nivel}`);
    if (!ctrl) return;
    if (required && this.taxonomiaActiva) {
      ctrl.setValidators([Validators.required]);
    } else {
      ctrl.clearValidators();
    }
    ctrl.updateValueAndValidity();
  }

  private initTaxonomiaCabeceraWatch(): void {
    if (this.taxonomiaCabeceraWatchInited || !this.taxonomiaActiva) {
      return;
    }
    this.taxonomiaCabeceraWatchInited = true;
    const names = ["TXCentroCosteId", "iTXTipoPrecioId", "iTXCanalVentasId"];
    for (const name of names) {
      this.editorRegistroForm
        .get(name)
        ?.valueChanges.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(() => {
          if (this.loading) {
            return;
          }
          this.reiniciarNivelesTaxonomiaTrasCambioCabecera();
        });
    }
  }

  private reiniciarNivelesTaxonomiaTrasCambioCabecera(): void {
    if (!this.taxonomiaActiva || this.loading) {
      return;
    }
    for (let n = 1; n <= 7; n++) {
      this.editorRegistroForm
        .get(`Nivel${n}`)
        ?.setValue(null, { emitEvent: false });
      if (n >= 2) {
        this.txNiveles[n] = [];
      }
      this.actualizarValidadorNivel(n, false);
    }
    this.ultimoNivelTaxonomiaLeaf = null;
    this.taxonomiaRevenueCategory = "";
    this.taxonomiaCuentaVisitante = "";
    this.editorRegistroForm.patchValue(
      { iTXItemVentasId: null },
      { emitEvent: false }
    );
    this.actualizarValidadorNivel(1, true);
    void this.cargarNivelTaxonomia(1);
  }

  private async restaurarTaxonomiaDesdeRegistro(reg: any): Promise<void> {
    if (!this.taxonomiaActiva) return;
    const tax = reg?.Taxonomia ?? reg?.taxonomia;
    if (!tax || typeof tax !== "object") return;

    for (let n = 2; n <= 7; n++) {
      this.editorRegistroForm
        .get(`Nivel${n}`)
        ?.setValue(null, { emitEvent: false });
      this.txNiveles[n] = [];
      this.actualizarValidadorNivel(n, false);
    }
    this.editorRegistroForm.get("Nivel1")?.setValue(null, { emitEvent: false });
    this.taxonomiaRevenueCategory = "";
    this.taxonomiaCuentaVisitante = "";
    this.ultimoNivelTaxonomiaLeaf = null;

    let predecesorNombre: string | undefined;
    let lastItem: any = null;

    for (let n = 1; n <= 7; n++) {
      const rawNv = tax[`TXNivel${n}`];
      if (rawNv === undefined || rawNv === null || String(rawNv).trim() === "") {
        break;
      }
      const target = String(rawNv).trim();
      const nivel1YaCargado =
        n === 1 &&
        predecesorNombre === undefined &&
        Array.isArray(this.txNiveles[1]) &&
        this.txNiveles[1].length > 0;
      if (!nivel1YaCargado) {
        await this.cargarNivelTaxonomia(n, predecesorNombre, {
          refreshView: false,
        });
      } else if (this.taxonomiaActiva) {
        this.actualizarValidadorNivel(1, true);
      }
      const list = this.txNiveles[n] || [];
      const item = list.find(
        (it: any) =>
          String(it?.NivelNombre ?? "").trim() === target ||
          String(it?.TXItemVentasId ?? "") === target ||
          String(it?.pkId ?? "") === target
      );
      if (!item) {
        break;
      }
      lastItem = item;
      this.editorRegistroForm
        .get(`Nivel${n}`)
        ?.setValue(item, { emitEvent: false });
      predecesorNombre = item.NivelNombre;

      const esHoja =
        item.TieneSucesor === 0 ||
        item.TieneSucesor === "0" ||
        n === 7;
      if (esHoja) {
        this.ultimoNivelTaxonomiaLeaf = item;
        break;
      }
    }
    if (!this.ultimoNivelTaxonomiaLeaf && lastItem) {
      const hoja =
        lastItem.TieneSucesor === 0 || lastItem.TieneSucesor === "0";
      if (hoja) {
        this.ultimoNivelTaxonomiaLeaf = lastItem;
      }
    }

    const txItem =
      tax.TXItemVentasId ??
      tax.iTXItemVentasId ??
      lastItem?.TXItemVentasId ??
      lastItem?.pkId;
    if (txItem !== undefined && txItem !== null && txItem !== "") {
      this.editorRegistroForm.patchValue(
        { iTXItemVentasId: txItem },
        { emitEvent: false }
      );
    }

    this.taxonomiaRevenueCategory = (
      tax.RevenueCategory ??
      lastItem?.RevenueCategory ??
      ""
    ).toString();
    const cvRaw = tax.CuentaVisitante;
    const cv =
      cvRaw !== undefined && cvRaw !== null && `${cvRaw}` !== ""
        ? cvRaw
        : lastItem?.CuentaVisitante;
    const hoja =
      this.ultimoNivelTaxonomiaLeaf &&
      (this.ultimoNivelTaxonomiaLeaf.TieneSucesor === 0 ||
        this.ultimoNivelTaxonomiaLeaf.TieneSucesor === "0");
    this.taxonomiaCuentaVisitante = hoja
      ? this.textoCuentaVisitanteInformativo(cv)
      : "";
    this._cds.detectChanges();
  }

  private idTaxonomiaParaApi(
    list: any[],
    idSeleccion: any,
    clavesNegocio: string[]
  ): string {
    let fila: any = null;
    if (
      idSeleccion !== null &&
      idSeleccion !== undefined &&
      idSeleccion !== "" &&
      typeof idSeleccion === "object"
    ) {
      fila = idSeleccion;
    } else if (
      idSeleccion !== null &&
      idSeleccion !== undefined &&
      idSeleccion !== ""
    ) {
      const id = String(idSeleccion);
      fila = (list || []).find((x) => {
        if (!x) return false;
        if (String(x.pkId ?? "") === id || String(x.Id ?? "") === id) {
          return true;
        }
        return clavesNegocio.some((k) => String(x[k] ?? "") === id);
      });
    }
    if (!fila) {
      return EditEntryTypeComponent.strId(idSeleccion);
    }
    for (const k of clavesNegocio) {
      const val = fila[k];
      if (val !== null && val !== undefined && `${val}` !== "") {
        return String(val);
      }
    }
    return EditEntryTypeComponent.strId(fila.pkId ?? fila.Id ?? idSeleccion);
  }

  private buildTaxonomiaParaInsUpd(): EntryType["Taxonomia"] | null {
    if (!this.taxonomiaActiva) {
      return null;
    }
    const v = this.editorRegistroForm.getRawValue();
    const leaf = this.ultimoNivelTaxonomiaLeaf;
    const itemVentasSel = v.iTXItemVentasId ?? leaf ?? null;
    const centroDesdeHoja = EditEntryTypeComponent.idTaxonomiaDesdeNodoIfAny(
      leaf,
      ["TXCentroCosteId"]
    );
    const tipoDesdeHoja = EditEntryTypeComponent.idTaxonomiaDesdeNodoIfAny(
      leaf,
      ["TXTipoPrecioId", "iTXTipoPrecioId"]
    );
    const canalDesdeHoja = EditEntryTypeComponent.idTaxonomiaDesdeNodoIfAny(
      leaf,
      [
        "TXCanalVentasId",
        "iTXCanalVentasId",
        "CanalVentasId",
        "CanalVentaId",
      ]
    );
    const TXCentroCosteId = this.idTaxonomiaParaApi(
      this.txCentroCoste,
      centroDesdeHoja ?? v.TXCentroCosteId,
      ["TXCentroCosteId"]
    );
    const TXTipoPrecioId = this.idTaxonomiaParaApi(
      this.txTipoPrecio,
      tipoDesdeHoja ?? v.iTXTipoPrecioId,
      ["TXTipoPrecioId"]
    );
    const TXCanalVentasId = this.idTaxonomiaParaApi(
      this.txCanalVentas,
      canalDesdeHoja ?? v.iTXCanalVentasId,
      ["TXCanalVentasId"]
    );
    const TXItemVentasId = this.idTaxonomiaParaApi(
      [],
      itemVentasSel,
      ["TXItemVentasId"]
    );
    const alojRaw = v.TXAlojamientoId;
    const TXAlojamientoId =
      alojRaw === null || alojRaw === undefined || alojRaw === ""
        ? null
        : this.idTaxonomiaParaApi(this.txAlojamiento, alojRaw, [
            "TXAlojamientoId",
          ]);
    if (
      !TXCentroCosteId &&
      !TXTipoPrecioId &&
      !TXCanalVentasId &&
      !TXItemVentasId &&
      !TXAlojamientoId
    ) {
      return null;
    }
    return {
      TXCentroCosteId: TXCentroCosteId || null,
      TXCanalVentasId: TXCanalVentasId || null,
      TXTipoPrecioId: TXTipoPrecioId || null,
      TXAlojamientoId: TXAlojamientoId || null,
      TXItemVentasId: TXItemVentasId || null,
    };
  }

  closeInputFilter(enventValues: { name: string; value: any }): void {
    const ctrl = this.editorRegistroForm.get(enventValues.name);
    if (!ctrl) {
      return;
    }
    let v = enventValues.value;
    if (v === "" || v === "-1" || v === undefined) {
      v = null;
    }
    ctrl.setValue(v);
    ctrl.markAsTouched();
    ctrl.updateValueAndValidity({ emitEvent: true });
  }
}
